import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { ChartHelperService } from "../../chart/chart-helper.service";

@Component({
  selector: "ab-deploy-chart",
  templateUrl: "./deploy-chart.component.html",
})
export class DeployChartComponent implements OnChanges {
  @Input() public loading: boolean;
  @Input() public statData: any;

  public linechartData: any;

  constructor(private chartHelperService: ChartHelperService) {}

  public ngOnChanges(changes: SimpleChanges) {
    if (this.statData == null || changes.statData == null) {
      return;
    }

    this.linechartData = {
      data: {
        labels: this.statData.time,
        datasets: [
          {
            label: "Deploys",
            data: this.statData.count,
            backgroundColor: "#0882b7", // ab-blue-400
            borderColor: "#0882b7", // ab-blue-400
          },
        ],
      },
      options: this.chartHelperService.defaultChartOptions(),
    };
  }
}
